import { StorageCreateWarehouse } from '@features/storage-create-warehouse';
import { StorageFilter } from '@features/storage-filter';
import { StorageModeSelect } from '@features/storage-mode-select';
import { StorageSearchField } from '@features/storage-search';
import styles from './styles.module.css';
import { StorageSelectedBags } from '@/features/storage-selected-bags';

export const StorageControls = () => (
  <div className={styles.controls}>
    <StorageModeSelect />
    {/* <StorageSearchField /> */}
    <StorageSelectedBags/>
    <StorageFilter />
    <StorageCreateWarehouse />
  </div>
);
